import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  .container_contact_upload_csv {
    color: ${color.black2};
  }

  .container_contact_upload_download_text {
    cursor: pointer;
  }

  .ant-avatar {
    background: ${color.orange6};
    color: ${color.orange1};
    border: 1px solid ${color.black6};
    margin-right: 8px;
  }

  .container_contact_org_name_wrapper {
    display: flex;
    align-items: center;
  }

  .container_import_modal_total {
    span:first-child {
      color: ${color.green1};
    }
    span:nth-child(2) {
      color: ${color.red1};
    }
  }

  .anticon {
    width: 20px;
    height: 20px;
  }

  .anticon-check-circle {
    color: ${color.green1};
  }

  .anticon-warning {
    color: ${color.red1};
  }

  .container_contact_org_icon {
    margin-right: 8px;
  }

  .container_contact_upload_download_text {
    a {
      color: ${color.orange1};
    }
  }

  .container_contact_upload_drag {
    padding: 38px 24px;
    margin-bottom: 24px;
    border-radius: 12px;
  }

  .ant-upload.ant-upload-drag {
    text-align: left;
    background: ${color.grey4};
  }

  .ant-upload.ant-upload-btn {
    padding: 0px;
  }

  .container_contact_upload_text {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .container_contact_upload_btn {
    padding: 8px 16.5px;
    border-radius: 8px;
    background-color: ${color.grey2};
  }

  .container_import_modal_loading_text {
    text-align: center;
  }

  .component_contact_table {
    .ant-table {
      min-height: unset;
      box-shadow: unset;
    }
  }
`;

export default Wrapper;

export const UploadItem = styled.div`
  padding: 35px 24px;
  border: 1px dashed ${color.grey1};
  border-radius: 12px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .container_upload_item {
    display: flex;
  }

  .container_upload_item_text {
    color: ${color.black7};
  }

  .container_upload_item_icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 90px;
    background-color: ${color.grey1};
    color: ${color.purple1};
    margin-right: 12px;
  }

  .container_upload_delete_icon {
    color: ${color.red1};
    cursor: pointer;

    .anticon {
      width: 17px;
      height: 17px;
    }
  }
`;
